import React from 'react';
import PaginationControl from './pagination_control';

export default function(props) {
  return <PaginationControl {...props} />;
}
